import Seo from "@/components/np/Seo";
import SectionHeading from "@/components/np/SectionHeading";
import BookButton from "@/components/np/BookButton";
import FinalCta from "@/components/home/FinalCta";
import TreatmentBlock from "@/components/treatments/TreatmentBlock";
import ProcessSteps from "@/components/treatments/ProcessSteps";
import FaqList from "@/components/treatments/FaqList";
import { firstVisit, meta, treatments } from "@/content";

export default function Behandlingar() {
  return (
    <>
      <Seo {...meta.behandlingar} />
      <section className="page-hero" aria-labelledby="beh-title">
        <div className="container-np py-16 sm:py-20">
          <p className="eyebrow">Behandlingar</p>
          <h1 id="beh-title" className="mt-4 max-w-4xl font-serif text-5xl leading-[1.02] text-ink sm:text-6xl lg:text-7xl">Behandlingar hos Nordic Prolo</h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-muted">Alla behandlingar utförs av läkare och föregås av en bedömning. Här ser du kortfattat vad varje metod innebär och när den kan vara aktuell.</p>
          <nav aria-label="Hoppa till behandling" className="mt-10">
            <ul className="flex flex-wrap gap-2">
              {treatments.map((t) => (
                <li key={t.id}><a href={`#${t.id}`} className="chip" data-testid={`jump-${t.id}`}>{t.name}</a></li>
              ))}
            </ul>
          </nav>
        </div>
      </section>
      <section className="pb-8" aria-label="Behandlingar">
        <div className="container-np grid gap-6">
          {treatments.map((t, i) => <TreatmentBlock key={t.id} t={t} index={i} />)}
        </div>
      </section>
      <section className="py-16 sm:py-20 lg:py-24" aria-labelledby="first-visit-title">
        <div className="container-np grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <SectionHeading id="first-visit-title" eyebrow="Nybesök" title={firstVisit.title} />
            <ul className="mt-8 space-y-3">
              {firstVisit.points.map((p) => <li key={p} className="border-l-2 border-amber pl-4 text-ink">{p}</li>)}
            </ul>
            {firstVisit.extras.map((e) => <p key={e} className="mt-5 text-sm text-muted">{e}</p>)}
            <BookButton testId="first-visit-book-button" className="mt-8" />
          </div>
          <div className="lg:col-span-7"><ProcessSteps compact /></div>
        </div>
      </section>
      <section className="bg-sand/60 py-16 sm:py-20 lg:py-24" aria-labelledby="beh-faq-title">
        <div className="container-np grid gap-10 lg:grid-cols-12">
          <SectionHeading id="beh-faq-title" className="lg:col-span-4" eyebrow="Frågor" title="Vanliga frågor" />
          <div className="lg:col-span-8"><FaqList /></div>
        </div>
      </section>
      <div className="pt-16 sm:pt-20"><FinalCta /></div>
    </>
  );
}
